import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import {
    BaseTimeSeriesData,
    generateTimeSeriesDataId,
    LegacyMarketData
} from './time-series-data.model';

export interface TimeSeriesDataState extends EntityState<BaseTimeSeriesData> {
    ui: {
        lastEntryByUser: Date /* Date when user last modified a value during active session, value is used to determine if positions need to be updated */;
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'timeSeriesData' })
export class TimeSeriesDataStore extends EntityStore<TimeSeriesDataState> {
    constructor() {
        super({
            ui: {
                lastEntryByUser: null
            }
        });
    }

    akitaPreAddEntity(timeSeriesData: BaseTimeSeriesData<LegacyMarketData>) {
        if (!timeSeriesData.id || !timeSeriesData.timestamp) {
            return {
                id: generateTimeSeriesDataId(
                    timeSeriesData.instrumentId,
                    new Date(timeSeriesData.date)
                ),
                ...timeSeriesData,
                timestamp: new Date(timeSeriesData.date).getTime()
            };
        }
        return timeSeriesData;
    }

    akitaPreUpdateEntity(
        prevTimeSeriesData: BaseTimeSeriesData,
        nextTimeSeriesData: BaseTimeSeriesData
    ) {
        // return the same entity or modify it
        return nextTimeSeriesData;
    }
}
